/* Functions for getting feature flags env variables to prevent referencing them in many places */
export const getLDClientKey = () => process.env.REACT_APP_LAUNCHDARKLY_CLIENTID;
